import { TypedEventTarget } from '@halo/utils';

export class ServerTime extends TypedEventTarget<{
  sync: void;
}> {
  private static instance: ServerTime;
  private static storeKey = '_chat_server_time_';
  private serverTime: number = 0;
  private localTime: number = 0;
  private timerId: any;
  constructor(private getServerTime: () => Promise<number>) {
    if (ServerTime.instance) {
      return ServerTime.instance;
    }

    super();

    const [serverTime = Date.now(), localTime = Date.now()] = JSON.parse(
      localStorage.getItem(ServerTime.storeKey) || '[]'
    );

    ServerTime.instance = this;

    this.serverTime = serverTime;
    this.localTime = localTime;

    this.sync();
  }
  sync() {
    this.getServerTime().then((time) => {
      this.serverTime = time;
      this.localTime = Date.now();

      localStorage.setItem(
        ServerTime.storeKey,
        JSON.stringify([this.serverTime, this.localTime])
      );

      this.dispatchEvent(new Event('sync'));

      this.timerId = setTimeout(
        () => {
          this.sync();
        },
        1000 * 60 * 5
      );
    });
  }
  get time() {
    return this.serverTime + Date.now() - this.localTime;
  }
  [Symbol.dispose]() {
    clearTimeout(this.timerId);
  }
}
